import { React, useEffect, useState } from "react"
import { Card, CardContent } from "./ui/card"
import { Badge } from "./ui/badge"
import { AlertCircle } from "lucide-react"
import { useAuth0 } from "@auth0/auth0-react"
import { Link } from "react-router-dom"

export const FetchConflicts = ({ groupId }) => {
  const [conflicts, setConflicts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
   const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL
  useEffect(() => {
    const fetchConflicts = async () => {
      try {
         const token = await getAccessTokenSilently({
          authorizationParams: { audience: process.env.REACT_APP_API_AUDIENCE },
        })
        
        const response = await fetch(`${apiUrl}/api/conflicts?groupId=${groupId}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}`,"Content-Type": "application/json" }})

        if (!response.ok) {
          throw new Error("Failed to fetch conflicts")
        }
        const data = await response.json()
        setConflicts(data)
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    if (groupId) {
      fetchConflicts()
    }
  }, [apiUrl, getAccessTokenSilently, groupId])

  if (loading) {
    return <div className="group-inline-state">Loading conflicts...</div>
  }

  if (error) {
    return (
      <div className="group-error-state">
        <AlertCircle className="mx-auto h-8 w-8 mb-2" />
        <p>Error loading conflicts: {error}</p>
      </div>
    )
  }

  if (!conflicts || conflicts.length === 0) {
    return (
      <div className="group-empty-state">
        <p>No conflicts reported for this group.</p>
      </div>
    )
  }

  return (
    <div className="group-list-stack">
      {conflicts.map((conflict) => (
        <Link key={conflict.id} to={`/conflicts/${conflict.id}`} className="group-record-link">
          <Card className="group-record-card">
            <CardContent className="p-4">
              <div className="group-record-title-row">
                <h3>{conflict.title}</h3>
                <Badge className={conflict.isResolved ? "group-status-badge is-success" : "group-status-badge"}>
                  {conflict.status || (conflict.isResolved ? "Resolved" : "Open")}
                </Badge>
              </div>
              <p className="group-record-description">{conflict.description}</p>
              <div className="group-record-badges">
                <Badge className="group-soft-badge">{conflict.conflictType || "Coordination conflict"}</Badge>
                <Badge className="group-soft-badge">
                  Resolvers {conflict.acceptedResolverCount || 0}/{conflict.requiredResolverCount || 3}
                </Badge>
                {(conflict.parties?.length || 0) > 0 && (
                  <Badge className="group-soft-badge">{conflict.parties.length} parties</Badge>
                )}
              </div>
              {conflict.proposedResolution && !conflict.isResolved && (
                <p className="group-record-footnote">
                  Resolution proposed: {conflict.resolutionSupportCount || 0} support,
                  {" "}{conflict.resolutionConcernCount || 0} concern
                </p>
              )}
            </CardContent>
          </Card>
        </Link>
      ))}
    </div>
  )
}

export default FetchConflicts

